import createMatchListPage from "../components/MatchListPage";
import { defaultTransform } from "../hooks/useMatchEndpoint";

const normalizeStatus = (value?: string | null) =>
  String(value ?? "")
    .toLowerCase()
    .replace(/[\s_-]+/g, "")
    .trim();

export default createMatchListPage({
  getEndpoint: () => "/bureau/profiles/all?filter=not_responding",
  getHeaderTitle: () => "Not Responding Profiles",
  emptyMessage: "No not responding profiles found right now.",
  hideCounterFilters: true,
  transform: (payload) =>
    defaultTransform(payload).filter(
      (match) => normalizeStatus(match.followUpStatus) === "notresponding",
    ),
  buildExtraActions: ({ match, updateFollowUpStatus, updatePaymentStatus }) => {
    const currentStatus = normalizeStatus(match.followUpStatus);

    return [
      {
        id: "callback",
        label: "Move to Call Back",
        onClick: () => updateFollowUpStatus(match, "callback"),
        className: "border border-amber-200 text-amber-700 hover:bg-amber-50",
        mobileClassName: "bg-amber-500 text-white hover:bg-amber-600",
      },
      {
        id: "not_responding",
        label: "Move to Not Responding",
        onClick: () => updateFollowUpStatus(match, "not_responding"),
        disabled: currentStatus === "notresponding",
        className:
          currentStatus === "notresponding"
            ? "bg-rose-100 text-rose-800 border border-rose-200"
            : "border border-rose-200 text-rose-700 hover:bg-rose-50",
        mobileClassName:
          currentStatus === "notresponding"
            ? "bg-rose-100 text-rose-800 border border-rose-200"
            : "bg-rose-600 text-white hover:bg-rose-700",
      },
      {
        id: "paid",
        label: "Move to Paid",
        onClick: () => updatePaymentStatus(match, "paid"),
        className: "border border-green-200 text-green-700 hover:bg-green-50",
        mobileClassName: "bg-green-600 text-white hover:bg-green-700",
      },
      {
        id: "free",
        label: "Move to Free",
        onClick: () => updatePaymentStatus(match, "free"),
        className: "border border-blue-200 text-blue-700 hover:bg-blue-50",
        mobileClassName: "bg-blue-600 text-white hover:bg-blue-700",
      },
      {
        id: "redzone",
        label: "Move to Red Zone",
        onClick: () => updatePaymentStatus(match, "redzone"),
        className: "border border-red-200 text-red-700 hover:bg-red-50",
        mobileClassName: "bg-red-600 text-white hover:bg-red-700",
      },
    ];
  },
});
